import { styled } from '@mui/material/styles';

import Modal from 'src/presentations/components/molecules/modal';
import { CircularProgress } from '@mui/material';
import { useDisputeSelector } from './Selector';
import { Dispute } from './Dispute';

const StyledModal = styled(Modal)({
  '& .MuiDialog-paper': {
    maxWidth: '64.5rem',
    height: 'calc(100% - 4rem)',
    borderRadius: '1rem',

    '& .MuiDialogContent-root': {
      padding: '1.25rem 0',
    },
  },
});

export const DisputeModal = () => {
  const { isShowModal, isLoadingDispute, closeDispute } = useDisputeSelector();

  return (
    <StyledModal open={isShowModal} onClose={closeDispute} fullWidth maxWidth='md'>
      {isShowModal && (
        <>
          {isLoadingDispute ? (
            <div className='p-32 xl:p-48 flex items-center justify-center'>
              <CircularProgress color='primary' />
            </div>
          ) : (
            <Dispute onClose={closeDispute} />
          )}
        </>
      )}
    </StyledModal>
  );
};
